var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 19 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.0625 15.625H5.9375C6.04063 15.625 6.125 15.5406 6.125 15.4375V4.5625C6.125 4.45937 6.04063 4.375 5.9375 4.375H4.0625C3.95937 4.375 3.875 4.45937 3.875 4.5625V15.4375C3.875 15.5406 3.95937 15.625 4.0625 15.625ZM8.5625 9.0625H10.4375C10.5406 9.0625 10.625 8.97812 10.625 8.875V4.5625C10.625 4.45937 10.5406 4.375 10.4375 4.375H8.5625C8.45938 4.375 8.375 4.45937 8.375 4.5625V8.875C8.375 8.97812 8.45938 9.0625 8.5625 9.0625ZM13.0625 10.75H14.9375C15.0406 10.75 15.125 10.6656 15.125 10.5625V4.5625C15.125 4.45937 15.0406 4.375 14.9375 4.375H13.0625C12.9594 4.375 12.875 4.45937 12.875 4.5625V10.5625C12.875 10.6656 12.9594 10.75 13.0625 10.75ZM18.125 0.625H0.875C0.460156 0.625 0.125 0.960156 0.125 1.375V18.625C0.125 19.0398 0.460156 19.375 0.875 19.375H18.125C18.5398 19.375 18.875 19.0398 18.875 18.625V1.375C18.875 0.960156 18.5398 0.625 18.125 0.625ZM17.1875 17.6875H1.8125V2.3125H17.1875V17.6875Z",
    fill: "#2A5578"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject);
export default __webpack_public_path__ + "static/media/project.68d4093ea39760ee9e329c6054245130.svg";
export { ForwardRef as ReactComponent };